import type {PayPalButtonsComponentOptions} from '@paypal/paypal-js/types';

const buttonStyle: PayPalButtonsComponentOptions['style'] = {
    color: 'gold',
    height: 48,
    label: 'checkout',
    layout: 'horizontal',
    shape: 'rect',
    tagline: false,
};

export default buttonStyle;
